module.exports = __webpack_public_path__ + "static/img/fzth.558ad55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/MemberCenter/assets/images/fzth.jpg
// module id = +tAL
// module chunks = 11